import(/* webpackMode: "eager", webpackExports: ["VaultClient"] */ "/codebuild/output/src1537574305/src/github.com/Singularity-DAO/sfi-frontend/apps/dapp/app/vaults/[id]/VaultClient.tsx");
